<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="13.5" stroke="white" stroke-width="3"/>
    <path d="M5.25 25.125L25.125 5.25" stroke="white" stroke-width="3"/>
</svg>
    